<template>
	<section class="ticket_select">
		<!-- <Nav title="" /> -->
		<van-nav-bar title="选择优惠券" right-text="不使用" left-arrow @click-right="backNoFn" @click-left="backFn" class="top_bar" />	
		<section class="list">
			<section class="user_c">
				<h2>当前可用优惠券</h2>
				<div class="item" v-for="(item, i) in listY" :key="item.id">
					<div class="item_info">
						<img src="../../../assets/img/ticket_bg_a.png" class="bg">
						<div class="left">
							<div class="left_info">
								<div v-if="item.couponType == 0"><p>{{item.couponDenomination}}</p><span>币</span></div>
								<div v-else-if="item.couponType == 1"><p>{{item.couponDenomination/100}}</p><span>元</span></div>
								<div v-else-if="item.couponType == 2"><p>{{(item.couponDenomination*10).toFixed(1)}}</p><span>折</span></div>
								<i v-if="item.couponType == 0">直接兑现，不可用于充值</i>
								<i v-else>充值满{{item.minAmount/100}}元可用</i>
							</div>
						</div>
						<div class="right">
							<h3>{{item.couponName}}</h3>
							<p class="time">{{item.useEndTime}}到期</p>
							<p class="rule_btn" @click="showRuleInfo(i, 'y')">
								使用规则
								<img src="../../../assets/img/ticket_down.png" v-if="!item.show">
								<img src="../../../assets/img/ticket_up.png" v-else>
							</p>
						</div>
						<div class="select_img" @click="chooseTicket(item.id)">
							<img src="../../../assets/img/check_a.png" v-if="activeId==item.id">
							<img src="../../../assets/img/check.png" v-else>
						</div>
					</div>
					<div class="rule_info" v-if="item.show">
						<p v-for="ruleT in item.couponRuleList" :key="ruleT">{{ruleT}}</p>
					</div>
				</div>
			</section>
			<section class="user_c user_n" v-if="listN.length>0">
				<h2>当前不可用优惠券</h2>
				<div class="item" v-for="(item, i) in listN" :key="item.id">
					<div class="item_info">
						<img src="../../../assets/img/ticket_bg_a.png" class="bg">
						<div class="left">
							<div class="left_info">
								<div v-if="item.couponType == 0"><p>{{item.couponDenomination}}</p><span>币</span></div>
								<div v-else-if="item.couponType == 1"><p>{{item.couponDenomination}}</p><span>元</span></div>
								<div v-else-if="item.couponType == 2"><p>{{(item.couponDenomination*10).toFixed(1)}}</p><span>折</span></div>
								<i v-if="item.couponType == 0"></i>
								<i v-else>充值满{{item.minAmount/100}}元可用</i>
							</div>
						</div>
						<div class="right_box">
							<p class="rule_no">请在我的-优惠券中直接使用</p>
							<div class="right">
								<h3>{{item.couponName}}</h3>
								<p class="time">{{item.useEndTime}}到期</p>
								<p class="rule_btn rule_btn_no" @click="showRuleInfo(i, 'n')">
									使用规则
									<img src="../../../assets/img/ticket_down.png" v-if="!item.show">
									<img src="../../../assets/img/ticket_up.png" v-else>
								</p>
							</div>
							<div class="select_img">
								<img src="../../../assets/img/check.png">
							</div>
						</div>
						
					</div>
					<div class="rule_info" v-if="item.show">
						<p v-for="ruleT in item.couponRuleList" :key="ruleT">{{ruleT}}</p>
					</div>
				</div>
			</section>
		</section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import ticketServer from "api/ticket";

export default {
	name: 'ticket-index',
	components: {
		Nav,
	},
	data() {
		return {
			loading: false,
			finished: false,
			listY: [],
			listN: [],
			activeId: '',
			isData: true,
			params: {
				pageNum: 0,
				pageSize: 100,
				history: 0,
			},
			activeIndex: 0
		}
	},
	created() {
		this.activeId = this.$route.query.id||''
		this.activeIndex = this.$route.query.index||0
		this.getTicket()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getTicket() {
			ticketServer.SearchMyTicket(this.params).then((res) => {
				res.data.list.forEach((item) => {
					item.show = 0
					item.couponRuleList = item.couponRule.split('#').filter((x) => x !== '');
					if(item.couponType) {
						this.listY.push(item)
					}else {
						this.listN.push(item)
					}
				})
			})
		},
		showRuleInfo(i, type) {
			if(type == 'y') {
				if(this.listY[i].show) {
					this.listY[i].show = 0
				}else {
					this.listY[i].show = 1
				}
			}else {
				if(this.listN[i].show) {
					this.listN[i].show = 0
				}else {
					this.listN[i].show = 1
				}
			}
			
			
		},
		chooseTicket(id) {
			this.activeId = id
			this.$router.push({name: 'full', query:{tickeid: id, index: this.activeIndex}})
		},
		
		backFn() {
			if(this.activeId) {
				this.$router.push({name: 'full', query:{tickeid: this.activeId, index: this.activeIndex}})
			}else {
				this.$router.push({name: 'full'})
			}
		},
		backNoFn() {
			this.$router.push({name: 'full'})
		}
	}
}
</script>

<style lang="scss">
	.ticket_select {
		img {
			display: block;
		}
		.van-nav-bar__right {
			.van-nav-bar__text {
				color: #575F72;
				font-size: 16px;
				font-weight: bold;
			}
		}
		
		padding-top: 46px;
		.fff {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: #fff;
			z-index: -1;
		}
		.list {
			.user_c {
				background: #fff;
				padding: 14px 18px;
				padding-bottom: 20px;
				h2 {
					color: #2B2F3A;
					font-size: 14px;
					padding-bottom: 13px;
				}
			}
			.user_n {
				margin-top: 15px;
				.item {
					.left,.right {
						opacity: .5;
					}
				}
			}
			.item {
				position: relative;
				margin-bottom: 20px;
				&:last-of-type {
					margin-bottom: 0;
				}
				.rule_info {
					width: 100%;
					margin-top: -5px;
					padding: 8px 11px;
					padding-top: 14px;
					border: 1Px solid #7E92E2;
					border-radius: 4px;
					border-top-left-radius: 0;
					border-top-right-radius: 0;
					border-top: 0;
					p {
						font-size: 12px;
						color: #7D8290;
					}
				}
			}
			.item_info {
				position: relative;
				width: 100%;
				height: 102px;
				.select_img {
					position: absolute;
					top: 50%;
					right: 12px;
					transform: translateY(-50%);
					z-index: 3;
					img {
						width: 20px;
					}
				}
				.bg {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.left {
					position: absolute;
					width: 108px;
					height: 100%;
					top: 0;
					left: 0;
					z-index: 2;
					.left_info {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%, -50%);
						div {
							text-align: center;
							p {
								display: inline-block;
								font-size: 28px;
								font-weight: bold;
								color: #3A5EEC;
							}
							span {
								display: inline-block;
								color: #3A5EEC;
								font-weight: bold;
								font-size: 12px;
								vertical-align: text-bottom;
							}
						}
						i {
							display: block;
							text-align: center;
							font-style: normal;
							font-size: 12px;
							color: #3A5EEC;
							transform: scale(.9);
						}
					}
				}
				.right_box {
					.rule_no {
						position: absolute;
						z-index: 2;
						left: 120px;
						top: 56px;
						color: #FC0E2D;
						font-size: 12px;
						font-weight: bold;
					}
				}
				.right {
					position: absolute;
					height: 100%;
					width: 231px;
					top: 0;
					left: 108px;
					z-index: 2;
					padding-top: 15px;
					padding-left: 12px;
					padding-bottom: 9px;
					h3 {
						font-size: 14px;
						color: #2B2F3A;
						font-weight: bold;
					}
					.time {
						color: #A2A6AE;
						font-size: 12px;
					}
					.rule_btn {
						margin-top: 20px;
						padding-top: 6px;
						color: #A2A6AE;
						font-size: 12px;
						display: flex;
						align-items: center;
						img {
							width: 10px;
							margin-left: 2px;
						}
					}
					.select_itme {
						position: absolute;
						right: 9px;
						bottom: 9px;
						width: 70px;
						height: 26px;
						line-height: 26px;
						text-align: center;
						color: #fff;
						font-size: 12px;
						background: #3A5EEC;
						border-radius: 20px;
					}


					// <h3>新人专享福利-加币券</h3>
					// 	<p class="time">2021.11.11-2021.11.14</p>
					// 	<p class="rule_btn">
					// 		使用规则
					// 		<img src="../../../assets/img/ticket_down.png">
					// 		<!-- <img src="../../../assets/img/ticket_up.png"> -->
					// 	</p>
					// 	<p class="select_itme">立即获取</p>

				}

			}
		}
		.nodata_class {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			img {
				width: 92px;
				margin: 0 auto;
			}
			p {
				color: #7D8290;
				font-size: 14px;
				text-align: center;
				padding-top: 11px;
				padding-bottom: 41px;
			}
			h4 {
				width: 127px;
				height: 36px;
				line-height: 36px;
				text-align: center;
				color: #fff;
				font-size: 14px;
				font-weight: bold;
				border-radius: 20px;
				background: #3A5EEC;
			}

		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/ticket/Select.vue